export default __webpack_public_path__ + "static/media/Diamond_Edge_large_2.e74fb46a.jpg";